import { Component, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ResourcesDialogModel } from "src/app/models/dialog";
import { ResourceLink } from "src/app/models/resource-link";

@Component({
    selector: 'mwp-dialog-card-resource',
    templateUrl: './card-resource.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogCardResourceComponent implements OnInit {
    public displayForm: boolean;
    public categroyResources: ResourceLink[];
    public companyResources: ResourceLink[];

    constructor(
        private dialogRef: MatDialogRef<DialogCardResourceComponent>,
        @Inject(MAT_DIALOG_DATA) public dialogData: ResourcesDialogModel,
    ) {
    }

    ngOnInit(): void {
        if (this.dialogData.categroyResources && this.dialogData.categroyResources.length > 0)
            this.categroyResources = this.dialogData.categroyResources;

        if (this.dialogData.companyResources && this.dialogData.companyResources.length > 0)
            this.companyResources = this.dialogData.companyResources;
    }

    public closeDialog(): void {
        this.dialogRef.close();
    }
}